module.exports = __webpack_public_path__ + "img/lets_chat_animated.f5c4af2.gif";